import { render, staticRenderFns } from "./DataMapping.vue?vue&type=template&id=6aced6a4&scoped=true"
import script from "./DataMapping.vue?vue&type=script&lang=js"
export * from "./DataMapping.vue?vue&type=script&lang=js"
import style0 from "./DataMapping.vue?vue&type=style&index=0&id=6aced6a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aced6a4",
  null
  
)

export default component.exports